import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 628 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5838_25976)">
      <path
        d="M0 3.73047H30.51C48.51 3.73047 59.92 14.0105 59.92 29.6005V29.8205C59.92 47.1805 45.99 56.2505 28.92 56.2505H13.6V81.1205H0V3.73047ZM29.41 43.9705C39.69 43.9705 46.1 38.2205 46.1 30.1505V29.9305C46.1 20.8605 39.58 16.1105 29.41 16.1105H13.6V43.9705H29.41Z"
        fill="#005586"
      />
      <path
        d="M98.0572 81.1201V73.9401C94.0572 78.6901 87.9972 82.3401 79.1572 82.3401C68.0972 82.3401 58.3672 76.0401 58.3672 64.3401V64.1201C58.3672 51.1801 68.4272 44.9901 82.0272 44.9901C87.5108 44.8834 92.9734 45.6981 98.1872 47.4001V46.2902C98.1872 38.2202 93.1072 33.8001 83.8172 33.8001C78.058 33.8199 72.3689 35.064 67.1272 37.4501L63.4772 26.7201C70.4133 23.418 78.0159 21.7552 85.6972 21.8601C102.947 21.8601 111.347 30.9301 111.347 46.5201V81.1201H98.0572ZM98.3972 56.6901C94.1116 55.1237 89.58 54.338 85.0172 54.3701C76.6072 54.3701 71.6372 57.7901 71.6372 63.4301V63.6501C71.6372 69.1801 76.6372 72.2801 82.9172 72.2801C91.7572 72.2801 98.3972 67.2801 98.3972 60.0001V56.6901Z"
        fill="#005586"
      />
      <path
        d="M119.188 0.410156H132.568V81.1201H119.188V0.410156Z"
        fill="#005586"
      />
      <path
        d="M141.953 0.410156H155.333V81.1201H141.953V0.410156Z"
        fill="#005586"
      />
      <path
        d="M160.75 52.1503V51.9303C160.75 35.2403 172.58 21.5303 189.27 21.5303C207.85 21.5303 217.27 36.1203 217.27 52.9303C217.27 54.1403 217.16 55.3603 217.05 56.6903H174.15C175.59 66.2003 182.34 71.5003 190.96 71.5003C197.48 71.5003 202.13 69.0703 206.77 64.5003L214.62 71.5003C209.09 78.1403 201.46 82.4503 190.74 82.4503C173.79 82.4503 160.75 70.1803 160.75 52.1503ZM203.98 47.8403C203.09 39.2203 197.98 32.4703 189.16 32.4703C180.98 32.4703 175.23 38.7803 174.01 47.8403H203.98Z"
        fill="#005586"
      />
      <path
        d="M224.652 64.9803V34.2402H217.242V22.7402H224.652V6.74023H238.022V22.7402H253.732V34.2402H238.022V62.8802C238.022 68.0802 240.682 70.1802 245.212 70.1802C248.096 70.1872 250.939 69.5013 253.502 68.1802V79.1202C249.829 81.1881 245.666 82.2247 241.452 82.1202C231.612 82.1202 224.652 77.8103 224.652 64.9803Z"
        fill="#005586"
      />
      <path
        d="M270.089 16.3305H245.539V3.73047H308.339V16.3305H283.799V81.1205H270.089V16.3305Z"
        fill="#005586"
      />
      <path
        d="M299.938 22.74H313.307V35.9C316.957 27.17 323.707 21.2 333.987 21.64V35.79H333.188C321.467 35.79 313.278 43.42 313.278 58.9V81.12H299.938V22.74Z"
        fill="#005586"
      />
      <path
        d="M373.02 81.1201V73.9401C369.02 78.6901 362.96 82.3401 354.11 82.3401C343.05 82.3401 333.32 76.0401 333.32 64.3401V64.1201C333.32 51.1801 343.38 44.9901 356.98 44.9901C362.461 44.8936 367.92 45.715 373.13 47.4201V46.2902C373.13 38.2202 368.04 33.8001 358.75 33.8001C352.991 33.8211 347.302 35.0652 342.06 37.4501L338.41 26.7201C345.346 23.418 352.949 21.7552 360.63 21.8601C377.88 21.8601 386.28 30.9301 386.28 46.5201V81.1201H373.02ZM373.35 56.6901C369.065 55.1229 364.533 54.3371 359.97 54.3701C351.57 54.3701 346.59 57.7901 346.59 63.4301V63.6501C346.59 69.1801 351.59 72.2801 357.87 72.2801C366.71 72.2801 373.35 67.2801 373.35 60.0001V56.6901Z"
        fill="#005586"
      />
      <path
        d="M390.367 52.0402V51.8202C390.367 32.4702 403.527 21.5302 417.457 21.5302C427.077 21.5302 433.157 26.3902 437.357 31.8102V0.410156H450.737V81.1201H437.357V71.3901C433.047 77.4701 426.967 82.3401 417.457 82.3401C403.747 82.3401 390.367 71.3902 390.367 52.0402ZM437.577 52.0402V51.8202C437.577 40.5402 429.577 33.1401 420.667 33.1401C411.487 33.1401 403.857 40.2102 403.857 51.8202V52.0402C403.857 63.3202 411.597 70.7302 420.667 70.7302C429.737 70.7302 437.577 63.2102 437.577 52.0402Z"
        fill="#005586"
      />
      <path
        d="M455.383 52.1503V51.9303C455.383 35.2403 467.213 21.5303 483.903 21.5303C502.483 21.5303 511.903 36.1203 511.903 52.9303C511.903 54.1403 511.793 55.3603 511.683 56.6903H468.783C470.213 66.2003 476.963 71.5003 485.583 71.5003C492.113 71.5003 496.753 69.0703 501.393 64.5003L509.243 71.5003C503.723 78.1403 496.093 82.4503 485.363 82.4503C468.423 82.4503 455.383 70.1803 455.383 52.1503ZM498.613 47.8403C497.723 39.2203 492.613 32.4703 483.793 32.4703C475.613 32.4703 469.863 38.7803 468.653 47.8403H498.613Z"
        fill="#005586"
      />
      <path
        d="M516.523 22.74H529.893V35.9C533.543 27.17 540.293 21.2 550.573 21.64V35.79H549.803C538.083 35.79 529.893 43.42 529.893 58.9V81.12H516.523V22.74Z"
        fill="#005586"
      />
      <path
        d="M587.602 21.7038V-2.7442H602.194V21.7038H626.77V35.7838H602.194V60.2318H587.602V35.7838H563.026V21.7038H587.602Z"
        fill="#FFB400"
      />
    </g>
    <defs>
      <clipPath id="clip0_5838_25976">
        <rect width={628} height={82} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;

SVGComponent.defaultProps = {
  width: '221px',
  height: '47px'
}